import { useRef, useEffect } from 'react';

/**
 * Track the previously given value in a ref.
 *
 * @param {*} value The value to track.
 *
 * @returns {*} The previous value.
 */
export default (value) => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
